import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TransactionContext {

  normalizeValue(v: any): any {

    if (v === null || v === undefined) return v;

    if (typeof v === 'object') {
      if ('id' in v) return v.id;
      if ('value' in v) return v.value;
    }

    return v;
  }

  buildHeader(raw: any) {

    const ctx: any = {};

    Object.keys(raw || {}).forEach(k => {
      ctx[k] = this.normalizeValue(raw[k]);
    });

    return ctx;
  }
}